import { Check, X } from "lucide-react";
import Reveal from "./Reveal";

const LANTIX_ROWS = [
  "Mobile-first discovery experience",
  "Focus on independent venues & local events",
  "Social & community-driven engagement",
  "Actionable data insights for promoters",
  "Personalized event recommendations",
  "Built for the underserved local ecosystem",
];

const LEGACY_ROWS = [
  "Desktop-first, friction-heavy UX",
  "Major venues & large events only",
  "Purely transactional, no social layer",
  "Limited promoter analytics & insights",
  "Generic, non-personalized browsing",
  "Ignores independent & local event market",
];

export default function VsLegacy() {
  return (
    <section id="versus" className="relative py-24 lg:py-32">
      <div
        className="pointer-events-none absolute right-[-10%] top-1/4 h-[480px] w-[480px] rounded-full bg-brand-purple opacity-20 blur-[170px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <span className="w-max rounded-full border border-brand-gold/40 bg-brand-gold/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-brand-gold">
            Competitive differentiation
          </span>
          <h2 className="mt-5 max-w-3xl font-display text-3xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            A challenger built for the <span className="text-gradient">local ecosystem.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2" data-testid="versus-grid">
          <Reveal>
            <article className="h-full rounded-3xl border border-brand-teal/30 bg-gradient-to-b from-[#0d1f16]/60 to-brand-card/90 p-7 shadow-[0_0_70px_rgba(66,246,143,0.09)] lg:p-9" data-testid="versus-lantix-card">
              <div className="flex items-center justify-between">
                <h3 className="font-brand text-lg font-bold tracking-[0.12em] text-brand-paper">LANTIX</h3>
                <span className="rounded-full bg-brand-teal/15 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-brand-teal">
                  The new layer
                </span>
              </div>
              <ul className="mt-8 space-y-5">
                {LANTIX_ROWS.map((row, i) => (
                  <li key={i} className="flex items-start gap-3.5">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-teal/15 text-brand-teal">
                      <Check className="h-3.5 w-3.5" />
                    </span>
                    <span className="text-sm font-medium leading-relaxed text-brand-paper/90">{row}</span>
                  </li>
                ))}
              </ul>
            </article>
          </Reveal>

          <Reveal delay={0.12}>
            <article className="h-full rounded-3xl border border-brand-mist/10 bg-brand-card/60 p-7 lg:p-9" data-testid="versus-legacy-card">
              <div className="flex items-center justify-between">
                <h3 className="font-display text-lg font-bold uppercase tracking-wide text-brand-mist/60">
                  Legacy platforms
                </h3>
                <span className="rounded-full bg-white/5 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-brand-mist/50">
                  The incumbents
                </span>
              </div>
              <ul className="mt-8 space-y-5">
                {LEGACY_ROWS.map((row, i) => (
                  <li key={i} className="flex items-start gap-3.5">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/5 text-brand-mist/40">
                      <X className="h-3.5 w-3.5" />
                    </span>
                    <span className="text-sm leading-relaxed text-brand-mist/50">{row}</span>
                  </li>
                ))}
              </ul>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
